module.exports = __webpack_public_path__ + "static/media/1.23c3eb3c.jpg";